export const MEMBERSHIP_STATUS = {
  active: { label: "Активен", tone: "success" },
  pending: { label: "Ожидает оплаты", tone: "warn" },
  expired: { label: "Истёк", tone: "muted" },
  frozen: { label: "Заморожен", tone: "warn" },
  cancelled: { label: "Отменён", tone: "muted" },
};

export function membershipStatusMeta(status) {
  return MEMBERSHIP_STATUS[status] || { label: status || "—", tone: "muted" };
}

export function formatMembershipPeriod(membership) {
  if (!membership) return null;
  const parts = [];
  if (membership.starts_at) {
    parts.push(
      new Date(membership.starts_at).toLocaleDateString("ru-RU", {
        day: "numeric",
        month: "short",
        year: "numeric",
      }),
    );
  }
  if (membership.ends_at) {
    parts.push(
      new Date(membership.ends_at).toLocaleDateString("ru-RU", {
        day: "numeric",
        month: "short",
        year: "numeric",
      }),
    );
  }
  if (parts.length === 2) return `${parts[0]} — ${parts[1]}`;
  if (parts.length === 1) return parts[0];
  return null;
}

export function membershipVisitsLine(membership, stats) {
  const mv = stats?.membership_visits;
  if (mv?.is_visit_based && mv.total != null) {
    const left = mv.remaining ?? membership?.visits_remaining;
    return `${left ?? "—"} из ${mv.total} занятий`;
  }
  if (membership?.visits_remaining != null) {
    return `${membership.visits_remaining} занятий осталось`;
  }
  return null;
}
